import React, { useEffect, useMemo, useState } from 'react';
import { Table } from '@mui/material';
import {
  StyledFooterLoading,
  StyledTable,
  StyledTableScrollbar,
} from './index.style';
import CustomTableBody from './TableBody';
import TableFooterNew from './TableFooterNew';
import NoData from '../NoData';

const CustomTable = ({
  flickerBackground,
  columns,
  onChangeRowPage,
  rowsPerPage,
  isExpand,
  data,
  total,
  page,
  dropTable,
  cellWidth,
  selected = [],
  loading,
  setNumSelected,
  headerPadding,
  showNumber,
  onChangePage,
  onSelect,
  onRowClick,
  minWidth,
  tableHeight,
  isStickyHeader = false,
  isShowCheckbox = true,
  limit,
  heightTableProjects,
  rowsPerPageOptions,
  detailsApp,
  noDataText,
  noDataImage,
}) => {
  const [showScrollbar, setShowScrollbar] = useState(false);
  const isSelected = (row) =>
    selected.filter((item) => item.id === row.id).length > 0;

  const handleSelectRow = (row) => (event) => {
    const {
      id,
      title,
      audioLink,
      status,
      retentionPeriod,
      createdAt,
      latestRequestId,
    } = row;

    const isSelectedRow = selected.filter((item) => item.id === id).length > 0;

    if (event.target.checked && !isSelectedRow) {
      if (onSelect)
        onSelect([
          ...selected,
          {
            id,
            title,
            audioLink,
            status,
            retentionPeriod,
            createdAt,
            latestRequestId,
          },
        ]);
      if (setNumSelected) {
        setNumSelected((prev) => prev + 1);
      }
      return;
    }

    if (onSelect) {
      onSelect(selected.filter((item) => item.id !== id));
      if (setNumSelected) {
        setNumSelected((prev) => prev - 1);
      }
    }
  };

  useEffect(() => {
    const rowIds = data.map((rowData) => rowData.id);
    const filteredArray =
      selected.filter((row) => rowIds.includes(row.id)) || [];
    if (setNumSelected) {
      setNumSelected(filteredArray.length);
    }
  }, [selected, data]);

  const HEIGHT_TATBLE_NEW_PAGINATION_NOT_EXPAND = '0px';
  const HEIGHT_TATBLE_NEW_PAGINATION_EXPAND = tableHeight;
  const HEIGHT_TATBLE_MULTILE_ITEM = '84px';

  const heightTable = useMemo(() => {
    if (heightTableProjects && data?.length > 0) {
      return heightTableProjects;
    }
    if (!isExpand) {
      return HEIGHT_TATBLE_NEW_PAGINATION_NOT_EXPAND;
    }
    if (isExpand && !!data?.length) {
      return HEIGHT_TATBLE_NEW_PAGINATION_EXPAND;
    }
    if (dropTable && data?.length > 1) {
      return HEIGHT_TATBLE_MULTILE_ITEM;
    }
    return data?.length > 0 ? tableHeight : 'max-content';
  }, [data, dropTable, tableHeight, isExpand, heightTableProjects]);
  const PAGE_SHOW_FLICKER_NEW_PAGINATION = 0;

  return (
    <>
      <StyledTableScrollbar detailsApp={detailsApp}>
        <StyledTable
          detailsApp={detailsApp}
          height={heightTable}
          heightTableProjects={heightTableProjects}
          cellWidth={cellWidth}
          headerPadding={headerPadding}
          stickyHeader={isStickyHeader}
          isFlickerBg={
            flickerBackground && page === PAGE_SHOW_FLICKER_NEW_PAGINATION
          }
          onMouseEnter={() => setShowScrollbar(true)}
          onMouseLeave={() => setShowScrollbar(false)}
          className={`sidebar-wrapper ${
            showScrollbar ? 'small-scrollbar' : 'hidden-scrollbar'
          } `}
        >
          <Table style={{ minWidth }} stickyHeader={isStickyHeader}>
            <CustomTableBody
              page={page}
              dropTable={dropTable}
              columns={columns}
              data={data}
              tableHeight={tableHeight}
              selection
              showNumber={showNumber}
              onChangePage={onChangePage}
              isSelected={isSelected}
              loading={loading}
              onSelectRow={handleSelectRow}
              onRowClick={onRowClick}
              isShowCheckbox={isShowCheckbox}
            />
          </Table>
        </StyledTable>
      </StyledTableScrollbar>

      {isExpand && data.length > 0 && (
        <TableFooterNew
          total={total}
          page={page}
          rowsPerPage={rowsPerPage}
          onChangeRowPage={onChangeRowPage}
          onChangePage={onChangePage}
          limit={limit}
          rowsPerPageOptions={rowsPerPageOptions}
        />
      )}

      {!loading && !data?.length ? (
        <div>
          <NoData
            dropTable={dropTable}
            height={dropTable ? '131px' : '326px'}
            noDataText={noDataText}
            image={noDataImage}
          />
        </div>
      ) : null}
      {loading && !data?.length && <StyledFooterLoading />}
      {loading && !data.length && dropTable && (
        <div>
          <StyledFooterLoading />
        </div>
      )}
    </>
  );
};

export default CustomTable;
